export default "__VITE_ASSET__DLRyvFO___"